import request from '@/api-v2/request';
import type { PdfParametersResponseDTO } from './types/pdf-parameters';

export const getPdfParameters = (signal: AbortSignal): Promise<PdfParametersResponseDTO> =>
  request({
    url: `/teams/pdf-parameters`,
    method: 'GET',
    signal,
  }).then((o) => o.data);
